import addMinutes from 'date-fns/add_minutes';

import { customLocalStorage } from '@crehana/utils';

export function setRecentlyLoggedStatus() {
  customLocalStorage.setItem(
    'CREHANA__USER_JUST_LOGGED',
    addMinutes(new Date(), 2).toISOString(),
  );
}

export default setRecentlyLoggedStatus;
